import {Component, Input, Output, EventEmitter, OnInit, OnChanges} from '@angular/core';
import * as moment from 'moment';

@Component({
    selector: 'app-calendar-header',
    templateUrl: './calendar-header.component.html',
})

export class CalendarHeaderComponent implements OnInit, OnChanges {
    @Input() view: string;
    @Input() viewDate: Date;
    @Input() locale: string = 'en';
    @Output() viewChange: EventEmitter<string> = new EventEmitter();
    @Output() viewDateChange: EventEmitter<Date> = new EventEmitter();
    weekday: string;
    month: string;
    day: string;
    year: string;

    ngOnInit(): void {
        this.weekday = moment(this.viewDate).format('dddd');
        this.month = moment(this.viewDate).format('MMMM');
        this.day = moment(this.viewDate).format('D');
        this.year = moment(this.viewDate).format('YYYY');
    }

    ngOnChanges(): void {
        this.weekday = moment(this.viewDate).format('dddd');
        this.month = moment(this.viewDate).format('MMMM');
        this.day = moment(this.viewDate).format('D');
        this.year = moment(this.viewDate).format('YYYY');
    }

}
